export namespace DriverDocumentConstants {
  export const DAYS_BEFORE_EXPIRATION_TO_FLAG = 30;
  export enum Status {
    Approved,
    Pending,
    Rejected,
    Expiring,
    Expired
  }
}
